__turbopack_context__.v({
  "cardGrid": "Home-module__blksQW__cardGrid",
  "code": "Home-module__blksQW__code",
  "emptyCard": "Home-module__blksQW__emptyCard",
  "emptyEmoji": "Home-module__blksQW__emptyEmoji",
  "layout": "Home-module__blksQW__layout",
  "main": "Home-module__blksQW__main",
  "navItem": "Home-module__blksQW__navItem",
  "navSection": "Home-module__blksQW__navSection",
  "navTitle": "Home-module__blksQW__navTitle",
  "pageHeader": "Home-module__blksQW__pageHeader",
  "pageSubtitle": "Home-module__blksQW__pageSubtitle",
  "pageTitle": "Home-module__blksQW__pageTitle",
  "priceGroup": "Home-module__blksQW__priceGroup",
  "priceGroupCount": "Home-module__blksQW__priceGroupCount",
  "priceGroupHeader": "Home-module__blksQW__priceGroupHeader",
  "priceGroupLabel": "Home-module__blksQW__priceGroupLabel",
  "sidebarGroup": "Home-module__blksQW__sidebarGroup",
  "sidebarGroupLabel": "Home-module__blksQW__sidebarGroupLabel",
  "sidebarHeader": "Home-module__blksQW__sidebarHeader",
  "sidebarTitle": "Home-module__blksQW__sidebarTitle",
  "sidebarVersion": "Home-module__blksQW__sidebarVersion",
});
